"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Image, { ImageProps } from "next/image";

/**
 * A React functional component that renders an image with a fade-in effect upon successful loading.
 * Fails gracefully by rendering nothing if an error occurs while loading the image.
 *
 * @param {ImageProps} props The properties passed to the Image component, including source, styles, and other attributes.
 * @return {JSX.Element|null} A styled image component with fade-in effect or null if an error occurs during loading.
 */
export function FadeFailSafeImage(t0) {
  const $ = _c(11);
  let props;
  let style;
  if ($[0] !== t0) {
    ({
      style,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = style;
  } else {
    props = $[1];
    style = $[2];
  }
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState(false);
  if (err) {
    return null;
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOk(true);
    t2 = () => setErr(true);
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  const t3 = ok ? 1 : 0;
  let t4;
  if ($[5] !== style || $[6] !== t3) {
    t4 = {
      ...style,
      opacity: t3,
      transition: "opacity .35s ease",
      display: "block"
    };
    $[5] = style;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props || $[9] !== t4) {
    t5 = <Image {...props} alt={props.alt} onLoad={t1} onError={t2} style={t4} />;
    $[8] = props;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}